import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import zh from './locales/zh.json'
import ms from './locales/ms.json'
import ta from './locales/ta.json'
import th from './locales/th.json'

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
    ms: { translation: ms },
    ta: { translation: ta },
    th: { translation: th },
  },
  lng: 'en', // Initial language; overridden by persisted preference
  fallbackLng: 'en', // Never render raw keys; always fall back to English
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  returnNull: false, // Never return null
  returnEmptyString: false, // Never return empty string for missing keys
  saveMissing: true, // Enable missing key detection
  missingKeyHandler: (lngs, ns, key, fallbackValue) => {
    // Log to observability; do not show the key to users
    console.error(`Missing i18n key "${key}" in ${lngs}/${ns}`, {
      fallbackValue,
      timestamp: new Date().toISOString(),
    })

    // In production, you would send this to your monitoring service
    // e.g., Sentry, DataDog, etc.
  },
  // Ensure components re-render correctly on language change
  react: {
    useSuspense: false,
    bindI18n: 'languageChanged loaded',
    bindI18nStore: 'added removed',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  },
})

export default i18n
